import * as React from 'react'
import { cn } from '@/lib/utils'

export interface TitleProps extends React.HTMLAttributes<HTMLDivElement> {
	title?: string
	subtitle?: string
}

const Title = React.forwardRef<HTMLDivElement, TitleProps>(({ title, subtitle, ...props }, ref) => {
	return (
		<div ref={ref} className={cn('text-left hidden md:block')} {...props}>
			<h1 className="text-3xl text-gray-900 font-[650]">{title}</h1>
			<h2 className="text-gray-600">{subtitle}</h2>
		</div>
	)
})
Title.displayName = 'Title'

export { Title }
